import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FeedbackComponent, UiComponent } from 'components';
import { EVENT_MENU_URL } from 'data/menu';
import { SearchFeedbackFilterType } from 'types';
import { useIsMobile, usePageOption } from 'hooks';
import { FeedbackQuery } from 'queries';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchFeedbackFilterType>({});

  const { data } = FeedbackQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <FeedbackComponent.List
      toolbar={
        <FeedbackComponent.Filter filter={filter} handleFilter={setFilter} />
      }
      {...pageState}
      totalPage={data?.totalPages}
      data={data?.data || []}
    />
  );
}

function MobileList() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<SearchFeedbackFilterType>({});
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    FeedbackQuery.useGetInfinite(filter);

  return (
    <UiComponent.MobileTitleList
      pageTitle={
        <UiComponent.PageTitle>피드백 템플릿 목록</UiComponent.PageTitle>
      }
      items={data ?? []}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      onSelect={(id: number) =>
        navigate(`${EVENT_MENU_URL['피드백 템플릿']}/${id}`)
      }
      onSearch={(title) => setFilter({ title })}
      emptyText="피드백 템플릿이 없습니다"
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  if (isMobile) return <MobileList />;

  return (
    <>
      <UiComponent.PageTitle>피드백 템플릿 목록</UiComponent.PageTitle>
      <DesktopList />
    </>
  );
}

export default List;
